import moment from "moment";

/**
 * Получение минимальной fromDate и максимальной toDate для списка версий
 * @param {}
 * @return {}
 */

export const getVersionsDateRange = <T extends { fromDate?: string; toDate?: string }>(
  versions: T[]
): { fromDate?: string; toDate?: string } => {
  let fromDate: string | undefined;
  let toDate: string | undefined;
  const hideTsError = versions.forEach((version) => {
    if (version.fromDate) {
      const isEarlierVersion = moment(version.fromDate).isBefore(fromDate);
      if (!fromDate || isEarlierVersion) {
        fromDate = version.fromDate;
      }
      if (version.toDate) {
        const isLaterVersion = moment(version.toDate).isAfter(toDate);
        if (!toDate || isLaterVersion) {
          toDate = version.toDate;
        }
      }
    }
  });
  return {
    fromDate,
    toDate,
  };
};
